<ng-select placeholder="{{ 'lblSelectDealer' | translate }}" [(ngModel)]="selectedDealer" [clearable]="clear"
(change)="setDealer($event)" (keyup.enter)="setDealer($event)" [disabled]="disabled">
    <ng-option *ngFor="let dealer of dealerList" [value]="dealer.value" >
          {{dealer.text}}
    </ng-option>
</ng-select>